import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledTextCell = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    ${setFontVariant("body2", colorsPalettes.carbon[250])}
`;

export const StyledDomain = styled.span<{ isPrimary: boolean; isLink: boolean }>`
   ${({ isLink }) => {
       return isLink
           ? ` cursor: pointer;
    ${setFontVariant("input2", colorsPalettes.blue[400])};`
           : `
     ${setFontVariant("body2", colorsPalettes.carbon[400])};
    `;
   }}

    ${({ isPrimary }) =>
        isPrimary
            ? css`
                  font-weight: 500;
              `
            : css`
                  font-weight: 400;
              `}

    & .ItemIcon {
        ${({ isPrimary }) =>
            isPrimary
                ? css`
                      border: 2px solid ${colorsPalettes.blue[400]};
                  `
                : css`
                      border: 1px solid ${colorsPalettes.carbon[100]};
                  `}
    }
`;

export const PrimaryStringContainer = styled(Flex)`
    align-items: center;
    gap: 4px;
`;

export const PrimaryDomainText = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
`;
